@if (spec) {
    <div class="lm-builder-summary-fields-container">
        <div class="lm-builder-summary-fields-list-container">
            <input
                soho-checkbox
                type="checkbox"
                id="lm-builder-summary-total-instance-count"
                data-automation-id="lm-builder-summary-total-instance-count"
                soho-trackdirty
                [(ngModel)]="instanceCount"
                [disabled]="false"
                (change)="updateInstanceCount()">
            <label soho-label for="lm-builder-summary-total-instance-count" [forCheckBox]="true" data-automation-id="lm-builder-summary-total-label">{{ 'ShowRecordCount' | translate }}</label>
        </div>
        <div class="lm-builder-total-header-info">
            <p>{{ 'SummaryTotalsDescription' | translate }}</p>
        </div>
        <div
            class="lm-builder-summary-field-boundary"
            cdkDropList
            [id]="LMBuilderModel.SUMMARY_TOTAL_LIST"
            [cdkDropListConnectedTo]="[LMBuilderModel.FACADE_FIELD_PICKER_FIELDS_LIST, LMBuilderModel.SUMMARY_TOTAL_LIST]"
            [cdkDropListData]="LMBuilderModel.SUMMARY_TOTAL_LIST"
            [cdkDropListEnterPredicate]="canDrop"
            (cdkDropListDropped)="drop($event)">
            @if (lmBuilderModel.summaryTotalFields.length > 0)   {
                @for (totalField of lmBuilderModel.summaryTotalFields; track totalField.fieldId ) {
                    <div cdkDragBoundary="lm-builder-summary-field-boundary" cdkDrag [cdkDragData]="totalField" class="lm-builder-summary-fields-list-container">
                        <div *cdkDragPreview class="lm-builder-summary-fields-list-container">
                            <svg [attr.data-automation-id]="'lm-builder-summary-total-field' + $index + '-type-icon'" soho-icon class="lm-builder-icon dim" [icon]="totalField.type === 'date' ? 'calendar' : 'number'" soho-tooltip [content]="totalField.type === 'date' ? 'Date' : 'Number'"/>
                            <div><p>{{totalField.fieldId}}</p></div>
                        </div>
                        <div class="lm-builder-total-field">
                            <svg [attr.data-automation-id]="'lm-builder-summary-total-field' + $index + '-type-icon'" soho-icon class="lm-builder-icon dim" [icon]="totalField.type === 'date' ? 'calendar' : 'number'" soho-tooltip [content]="totalField.type === 'date' ? 'Date' : 'Number'"/>
                            <div class="lm-builder-summary-field-label">
                                <p soho-tooltip [content]="totalField.fieldId" [attr.data-automation-id]="'lm-builder-summary-total-field-' + $index + '-text'">{{totalField.fieldId }}</p>
                                <div>
                                    <a (click)="removeField(totalField)">
                                        <svg [id]="'lm-builder-total-field' + $index + '-remove-icon'" [attr.data-automation-id]="'lm-builder-summary-total-' + $index + '-remove-icon'" class="lm-builder-display-field-hover-icon" soho-icon [icon]="'close-small'" soho-tooltip [content]="'Remove' | translate"/>
                                    </a>
                                </div>
                            </div>
                        </div>
                        <div class="lm-builder-total-operators">
                            @for (operatorModel of totalField.operatorModels; track operatorModel.dai ) {
                                <input
                                        soho-checkbox
                                        type="checkbox"
                                        [id]="operatorModel.dai"
                                        [attr.data-automation-id]="operatorModel.dai"
                                        [(ngModel)]="operatorModel.checked"
                                        [disabled]="false"
                                        (change)="updateTotalField(totalField, operatorModel)">
                                <label soho-label [for]="operatorModel.dai" data-automation-id="lm-builder-summary-total-label" class="lm-checkbox-label">{{operatorModel.label}}</label>
                            }
                        </div>
                    </div>
                }
                <div class="empty-title" soho-emptymessage
                     [info]="'AddNumericOrDateFields' | translate">
                </div>
            } @else {
                <div class="empty-title" soho-emptymessage
                     [title]="'AddSummaryTotals' | translate"
                     [info]="'AddNumericOrDateFields' | translate">
                </div>
            }
        </div>
    </div>
}
